module.exports = __webpack_public_path__ + "img/activity.ea3f7e51.png";